/**
 * Created by Darius on 2016.08.07.
 */
import React, {Component} from "react";
import {connect} from "react-redux";
import {Field, reduxForm} from "redux-form";
import {renderTextField} from "../../components/core/editors";
import {Dialog, FlatButton} from "material-ui";
import service from '../../services/dashboard-services';


class QueueEdit extends Component {
    constructor(props, context) {
        super(props, context);

        this.submitForm = this.submitForm.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
    }

    submitForm(data) {
        return this.props.onSubmit(data);
    }

    onCloseClick() {
        this.props.onCloseDialog();
    }

    render() {
        var self = this;

        const {handleSubmit, pristine, submitting, openEdit, queue} = this.props;

        const inputStyle = {width: "195px", marginRight: "10px"};
        const spanStyle = {width: "195px", display: "inline-block"};

        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.onCloseClick}
            />,
            <FlatButton
                label="Save"
                primary={true}
                keyboardFocused={true}
                disabled={submitting || pristine}
                onTouchTap={handleSubmit(this.submitForm)}
            />,
        ];

        return (
            <div>

                <Dialog
                    title={`Edit Queue - ${queue.Domain}`}
                    actions={actions}
                    modal={false}
                    open={openEdit}
                    onRequestClose={this.onCloseClick}
                    autoScrollBodyContent={true}
                >
                    <form onSubmit={handleSubmit(this.submitForm)} noValidate={true}>
                        <div>
                            <span style={spanStyle}>Status: <b>{queue.Status}</b></span>
                            <span style={spanStyle}>Sent: <b>{queue.Sent}</b></span>
                            <span style={spanStyle}>Queued: <b>{queue.Queued}</b></span>
                            <span style={spanStyle}>Newest: <b>{queue.Newest}</b></span>
                            <span style={spanStyle}>Oldest: <b>{queue.Oldest}</b></span>
                        </div>
                        <div>
                            <Field name="Domain" component={renderTextField} type="hidden" style={{display: "none"}}/>
                            <Field name="MaxQueues" component={renderTextField} hintText="Max Queues" floatingLabelText="Max Queues" style={inputStyle} autoComplete="off"/>
                            <Field name="MaxPerSession" component={renderTextField} hintText="Max Per Session" floatingLabelText="Max Per Session" style={inputStyle} autoComplete="off"/>
                            <Field name="MaxPerQueue" component={renderTextField} hintText="Max Per Queue" floatingLabelText="Max Per Queue" style={inputStyle} autoComplete="off"/>
                            <Field name="WaitTime" component={renderTextField} hintText="Wait Time" floatingLabelText="Wait Time" style={inputStyle} autoComplete="off"/>
                            <Field name="MXrefresh" component={renderTextField} hintText="Refresh" floatingLabelText="Refresh" style={inputStyle} autoComplete="off"/>
                        </div>
                        { submitting ? <LinearProgress mode="indeterminate"/> : null }
                    </form>
                </Dialog>

            </div>
        );
    }
}

const mapStateToProps = state => ({
    queue: state.dashboard.queue || {},
    initialValues: state.dashboard.queue,
    openEdit: state.dashboard.openEdit || false,
    domain: state.dashboard.domain,
    saveStatus: state.dashboard.saveStatus,
});

const mapDispatchToProps = dispatch => ({
    onCloseDialog: () =>
        dispatch({type: 'CLOSE_QUEUE_DIALOG'}),
    onSubmit: (queue) =>
        dispatch({type: 'SUBMIT_QUEUE', payload: service.DashboardServices.saveQueue(queue)})

});

QueueEdit.contextTypes = {
    router: React.PropTypes.any.isRequired
};

QueueEdit = reduxForm({
    form: 'queueEditForm',
    enableReinitialize: true
})(QueueEdit);

QueueEdit = connect(mapStateToProps, mapDispatchToProps)(QueueEdit);

export default QueueEdit;
